/* eslint-disable operator-linebreak */
import { aesDecrypt, encrypt as aesEncrypt } from 'fif-payments-encryption/app/common/common-codec';
// eslint-disable-next-line no-undef
const rsaCryptoLib = require('fif-payments-encryption/app/common/common-rsa-crypto-lib');

const publicKey =
  '-----BEGIN PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArc3Fg9zFBVEhAtXPQK2Z\n' +
  'eES4IYneXfe/CYW/068zzJCdwfqpWBk03kbM9EpYk5Og+cPDJIgyRbt4u3Zxizuj\n' +
  'dYHrds248b2ZMqsVESm6rVALvjLnRVkJsAc5V/hldcwjLItV9UCgbMr9/p2VtweM\n' +
  'nz+w6iDzyndiGamcEk9UgNoUH2clEnOJQ+eSbm2U1dQobsdtcn6S899CY4YIn98e\n' +
  'teOBpe8tr64gjS3gAjRwstWvEgDeJ9zJDaY4ClYGYmZ0QAkK763F12Tw0MGDfkOD\n' +
  'eIKlCzvWbT6NNuZJtfgzYWWy36n7+7wuFonLWD7iIgG3ByaNQfGVmxaQBOnQCSSP\n' +
  '0wIDAQAB\n' +
  '-----END PUBLIC KEY-----';

export const randomKey = () => {
  return (
    Math.random().toString(36).substr(2) +
    Math.random().toString(36).substr(2) +
    Math.random().toString(36).substr(2) +
    Math.random().toString(36).substr(2)
  );
};

export const encrypData = (request, k) => {
  const key = randomKey();
  sessionStorage.setItem(k, JSON.stringify(key));

  if (!request.data) {
    return { payload: '', key };
  }

  return { payload: aesEncrypt(key, JSON.stringify(request.data)), key };
};

export const removeKey = (k) => {
  sessionStorage.removeItem(k);
};

export const decrypData = (data, keyid) => {
  const key = JSON.parse(sessionStorage.getItem(keyid));
  const decrypted = aesDecrypt(key, data);
  return JSON.parse(decrypted);
};

export const getEncryptedKey = (key) => {
  return rsaCryptoLib.encrypt(key, publicKey);
};
